import React from 'react';
import Image from 'next/image';
import { containerCss, contentCss, contentIconCss, registerLinkCss } from './index.style';
import Link from 'next/link';

type EncourageRegisterProps = {
  continueUrl: string;
  goRegister: () => void;
};

export default function EncourageRegister({ continueUrl, goRegister }: EncourageRegisterProps) {
  return (
    <div className={containerCss}>
      <Image
        src="https://storage.googleapis.com/static-chotot-com/storage/icons/gif/gift_transparent.gif"
        alt="logo"
        width={38}
        height={38}
      />

      <p className={contentCss}>
        Nhận ngay <strong>20.000 ĐT</strong>
        <span>
          <Link href="https://chuongtrinh.chotot.com/dang-ky-tai-khoan-nhan-20k-dt" target="_blank">
            <Image
              className={contentIconCss}
              src="https://storage.googleapis.com/static-chotot-com/storage/icons/svg/arrow-square.svg"
              alt="arrow-square"
              width={16}
              height={16}
            />
          </Link>
        </span>
        khi tạo tài khoản và liên kết SĐT thành công,{' '}
        <span>
          <Link onClick={goRegister} href={`/register?continue=${continueUrl}`}>
            <strong className={registerLinkCss}>ĐĂNG KÝ NGAY</strong>
          </Link>
        </span>
      </p>
    </div>
  );
}
